import script from "./SignUpConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./SignUpConfirmation.vue?vue&type=style&index=0&id=42c048fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42c048fe"]])

export default __exports__